import React from "react";
import { WifiIcon } from "../../../styles/img/svg/WifiIcon";
import { ShowerIcon } from "../../../styles/img/svg/ShowerIcon";
import { BreakfastIcon } from "../../../styles/img/svg/BreakfastIcon";
import { KingBedIcon } from "../../../styles/img/svg/KingBedIcon";
import { SizeIcon } from "../../../styles/img/svg/SizeIcon";
import { UiContentCol } from "./UiPageElements";
import parse from "html-react-parser";

export function UiProductContent(props) {
    return (
        <>
            <div className="sb-product-content">{props.children}</div>
        </>
    );
}

export function UiProductContentMainTitle(props) {
    return (
        <>
            <div className="sb-product-content__main-title">
                <h3>
                    {props.title}
                    {props.points && (
                        <span>
                            - {props.points} points ({props.amount})
                        </span>
                    )}
                </h3>
            </div>
        </>
    );
}

export function UiProductContentSubTitle(props) {
    return (
        <>
            <div className="sb-product-content__sub-heading">
                <h3>{props.subtitle}</h3>
            </div>
        </>
    );
}

export function UiProductContentDescription(props) {
    return (
        <>
            <div className="sb-product-content__description">
                <p>
                    {typeof props.description != "undefined" &&
                        parse(props.description)}
                </p>
            </div>
        </>
    );
}
export function UiProductContentOverview(props) {
    return (
        <>
            <div className="sb-product-content__overview">
                <h4>{props.overviewTitle}</h4>
                <p>{props.description}</p>
                {props.children}
            </div>
        </>
    );
}

export function UiProductContentFeatures(props) {
    return (
        <>
            <div className="sb-product-content__features">
                {props.wifi && (
                    <div>
                        <WifiIcon />
                        Wi-fi
                    </div>
                )}
                {props.bathup && (
                    <div>
                        <ShowerIcon />
                        Bathup
                    </div>
                )}
                {props.breakfast && (
                    <div>
                        <BreakfastIcon />
                        Breakfast
                    </div>
                )}
                {props.kingbed && (
                    <div>
                        <KingBedIcon />
                        King bed
                    </div>
                )}
                {props.size && (
                    <div>
                        <SizeIcon />
                        4m x 6m
                    </div>
                )}
            </div>
        </>
    );
}

export function UiProductContentSection(props) {
    return (
        <>
            <div className="sb-product-content__section">{props.children}</div>
        </>
    );
}

export function UiProductTermsOfPurchase(props) {
    return (
        <>
            <div className="sb-product-content__terms-of-purchase">
                <h4>Terms of purchase</h4>
                <p> {props.description}</p>
            </div>
        </>
    );
}

export function UiPointBreakDownWr(props) {
    return (
        <>
            <div className="sb-points-break-down">
                <h5>Breakdown:</h5>
                {props.children}
            </div>
        </>
    );
}

export function UiPointBreakDownCol(props) {
    return (
        <>
            <div className="sb-points-break-down__col">
                <span className="sb-points-break-down__col-name">
                    {props.colName}:
                </span>
                <span className="sb-points-break-down__col-amount">
                    {props.amount}
                </span>
            </div>
        </>
    );
}
export function UiPointBreakDownHr(props) {
    return (
        <>
            <div className="sb-points-break-down__hr" />
        </>
    );
}

export function UiPointBreakDownBtnWr(props) {
    return (
        <>
            <div className="sb-points-break-down__btn-wr" {...props} />
        </>
    );
}

export function UiPaymentInformationWr(props) {
    return (
        <>
            <div className="sb-payment-option" {...props} />
        </>
    );
}

export function UiOrderDetails(props) {
    return (
        <>
            <div className="sb-order-details">
                {props.title && <h3>{props.title}</h3>}
                {props.children}
            </div>
        </>
    );
}

export function UiOrderDetailsColWr(props) {
    return (
        <>
            <div className="sb-order-details__col-wr">{props.children}</div>
        </>
    );
}

export function UiOrderDetailsLastColWr(props) {
    return (
        <>
            <div className="sb-order-details__col-last-wr">
                {props.children}
            </div>
        </>
    );
}

export function UiOrderDetailsLastCol(props) {
    return (
        <>
            <div className="sb-order-details__col-last">{props.children}</div>
        </>
    );
}

export function UiOrderDetailsLastColBtnWr(props) {
    return (
        <>
            <div className="sb-order-details__col-last-btn">
                {props.children}
            </div>
        </>
    );
}

export function UiOrderDetailsColName(props) {
    return (
        <>
            <div className="sb-order-details__col-name">{props.colName}:</div>
        </>
    );
}

export function UiOrderDetailsColLabel(props) {
    return (
        <>
            <div className="sb-order-details__col-label">{props.label}</div>
        </>
    );
}
export function UiOrderDetailsColStatus(props) {
    return (
        <>
            <div className="sb-order-details__col-status">
                {(props.status === "Completed" ||
                    props.status === "Expired" ||
                    props.status === "Failed" ||
                    props.status === "Ordered") && <span> {props.status}</span>}
            </div>
        </>
    );
}

export function UiHistoricGoalColStatus(props) {
    return (
        <>
            <div className="sb-order-details__col-status">
                <span> {props.status}</span>
            </div>
        </>
    );
}

export function UiOrderDetailsColValidUnit(props) {
    return (
        <>
            <div className="sb-order-details__col-valid-status">
                {props.validUnit}
            </div>
        </>
    );
}

export function UiOrderDetailsHr(props) {
    return (
        <>
            <div className="sb-order-details__hr" />
        </>
    );
}

export function UiVoucherDetailsWr(props) {
    return (
        <>
            <div className="sb-voucher-details-wr" {...props} />
        </>
    );
}
